export async function isUserLoggedIn(): Promise<boolean> {
    try {
        const res = await fetch('https://api.motivul.com/api/loggedIn', {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${localStorage.getItem("token")}`
            },
        });
        
        const data = await res.json();

        sessionStorage.setItem("loggedIn", "true");
        sessionStorage.setItem("username", data.userData.user.username);

        return true; // Return true if user is logged in
    } catch (error) {
        // Not logged in. Remove token in case it's expired, clear session storage, and return false
        localStorage.removeItem("token");
        sessionStorage.clear();
        return false; // Return false if user is not logged in
    }
}
